import { motion } from 'framer-motion';
import { Baby, Gamepad2, Sparkles } from 'lucide-react';
import { fadeUp, stagger } from '@/lib/motion';
import { COPY } from '@/lib/data';

const ICONS = { Baby, Gamepad2, Sparkles };
const GRADIENTS = {
    ninos: { card: 'bg-gradient-to-br from-[hsl(var(--kche-pink))] to-[hsl(var(--kche-purple))]', text: 'text-white' },
    jovenes: { card: 'bg-gradient-sky', text: 'text-white' },
    adultos: { card: 'bg-gradient-sunshine', text: 'text-[hsl(var(--kche-dark))]' },
};

export const AventuraParaTodos = () => (
    <section data-testid="home-aventura-todos" className="relative bg-background py-16 sm:py-20 lg:py-24">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
            <div className="text-center max-w-2xl mx-auto">
                <p className="text-sm font-bold font-display text-[hsl(var(--kche-pink))] uppercase tracking-wider">Aventura para todos</p>
                <h2 className="mt-1 text-3xl sm:text-4xl lg:text-5xl font-display font-bold">Diversión para <span className="text-gradient-fun">niños, jóvenes y adultos</span></h2>
                <p className="mt-3 text-muted-foreground text-base sm:text-lg">Un espacio pensado para que toda la familia comparta y se divierta junta.</p>
            </div>
            <motion.div initial="hidden" whileInView="show" viewport={{ once: true, amount: 0.2 }} variants={stagger} className="mt-10 grid gap-5 md:grid-cols-3">
                {COPY.aventura.map((card) => {
                    const Icon = ICONS[card.icon] || Sparkles;
                    const grad = GRADIENTS[card.key];
                    return (
                        <motion.div key={card.key} variants={fadeUp} data-testid="aventura-card" className={`relative overflow-hidden rounded-3xl ${grad.card} ${grad.text} p-7 sm:p-8 shadow-pop hover:scale-[1.02] transition-transform`}>
                            <div className="absolute -top-10 -right-10 w-32 h-32 rounded-full bg-white/15 blur-2xl" />
                            <span className="inline-flex items-center justify-center size-14 rounded-2xl bg-white/25 backdrop-blur">
                                <Icon className="size-7" />
                            </span>
                            <h3 className="mt-5 text-2xl sm:text-3xl font-display font-bold">{card.title}</h3>
                            <p className="mt-2 text-sm sm:text-base opacity-95">{card.desc}</p>
                        </motion.div>
                    );
                })}
            </motion.div>
        </div>
    </section>
);

export default AventuraParaTodos;
